module.exports = __webpack_public_path__ + "img/圆形图标.ac921c55.png";